import React from "react";

/**
 * Mini-diagrama do fluxo da API do fornecedor: o sistema do fornecedor envia o
 * catálogo (produtos, cores, categorias, imagens) para a Brinde.me e recebe a
 * confirmação. Mesma família visual do diagrama de API do brindeme_sistema —
 * só a direção principal muda (aqui o fornecedor é quem publica).
 */
export const SupplierApiArt = () => (
    <svg className="intro-art" viewBox="0 0 320 150" role="img" aria-label="O sistema do fornecedor envia o catálogo para a Brinde.me e recebe a confirmação">
        <rect x="6" y="40" width="104" height="70" rx="16" className="ia-node" />
        <text x="58" y="79" textAnchor="middle" className="ia-title">Seu sistema</text>
        <text x="58" y="93" textAnchor="middle" className="ia-sub">ERP · PDM</text>

        <rect x="210" y="40" width="104" height="70" rx="16" className="ia-node ia-node--brand" />
        <text x="262" y="79" textAnchor="middle" className="ia-title ia-title--brand">Brinde.me</text>
        <text x="262" y="93" textAnchor="middle" className="ia-sub">Catálogo</text>

        <text x="160" y="58" textAnchor="middle" className="ia-mini">envia</text>
        <line x1="118" y1="67" x2="200" y2="67" className="ia-line" />
        <polygon points="206,67 197,62.5 197,71.5" className="ia-arrow" />

        <line x1="120" y1="83" x2="202" y2="83" className="ia-line" />
        <polygon points="114,83 123,78.5 123,87.5" className="ia-arrow" />
        <text x="160" y="102" textAnchor="middle" className="ia-mini">confirma</text>

        <rect x="116" y="64" width="13" height="6" rx="3" className="ia-pkt ia-pkt--req" />
        <rect x="191" y="80" width="13" height="6" rx="3" className="ia-pkt ia-pkt--res" />
    </svg>
);

export default SupplierApiArt;
